// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const growlithe: PokeData = {
  "id": 58,
  "name": "growlithe",
  "height": 7,
  "weight": 190,
  "base_experience": 70,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "take-down",
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "agility",
    "flame-wheel",
    "reversal",
    "outrage",
    "crunch",
    "heat-wave",
    "helping-hand",
    "odor-sleuth",
    "howl",
    "flare-blitz",
    "fire-fang",
    "flame-burst",
    "retaliate",
    "play-rough"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "outrage",
    "crunch",
    "flare-blitz",
    "fire-fang",
    "play-rough",
    "fire-punch",
    "morning-sun",
    "blaze-kick",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 25,
    "item": null,
    "species": [
      {
        "name": "growlithe",
        "order": 63,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arcanine",
        "order": 64,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 58,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.25,
    "speed": 60,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
